import dynamic from 'next/dynamic';

const Img = dynamic(() => import('./Img'));
const Footer = dynamic(() => import('./Footer'), { loading: () => 'Loading...' });
const JobDetailsCard = dynamic(() => import('./JobDetailsCard'), { loading: () => 'Loading...' });
const Tabs = dynamic(() => import('./Tabs'));

import BundleLoader from './BundleLoader';
import Search from './Search';
import OfflineObserver from './offline';
const RadioGroup = dynamic(() => import('./RadioGroup'), { loading: () => 'Loading...' });
const RadioSelect = dynamic(() => import('./RadioSelect'), { loading: () => 'Loading...' });
const FormikRadio = dynamic(() => import('./RadioGroup/FormikRadio'), { loading: () => 'Loading...' });
const MyGeoAddress = dynamic(() => import('./Geoaddress'), { loading: () => 'Loading...' });
const CurrentLocation = dynamic(() => import('./CurrentLocation'), { loading: () => 'Loading...' });
const Checkbox = dynamic(() => import('./Checkbox'), { loading: () => 'Loading...' });
const SingleNotification = dynamic(() => import('./singleNotification'));
const NavDropdown = dynamic(() => import('./NavDropdown'));
const InputCard = dynamic(() => import('./InputCard'));
const Banner = dynamic(() => import('./Banner'));

export {
  Img,
  Footer,
  Tabs,
  JobDetailsCard,
  InputCard,
  Search,
  NavDropdown,
  OfflineObserver,
  RadioGroup,
  RadioSelect,
  FormikRadio,
  MyGeoAddress,
  CurrentLocation,
  Checkbox,
  SingleNotification,
  Banner,
  BundleLoader
};
